import { Link, type LinkProps } from '~/components/link'
import type { ContentScopedProps } from '../../content.types'
import { DISPLAY_NAME, useContentContext } from '../../content'

type IContentLinkProps = LinkProps

export function ContentLink(props: IContentLinkProps) {
  const { children, __scopeContent } =
    props as ContentScopedProps<IContentLinkProps>
  const { size } = useContentContext(DISPLAY_NAME, __scopeContent)

  const renderLabelSize = (): LinkProps['size'] => {
    return size === 'tiny' ? 'md' : 'ml'
  }

  return (
    <Link.Root size={renderLabelSize()} data-testid="content-link" icon>
      {children}
    </Link.Root>
  )
}
